import { useEffect } from 'react';
import useSWRMutation from 'swr/mutation';
import { useAuthStore } from '../../auth/stores/use-auth-store';
import {
  COMPLAINT_CHAT_TOPIC_PURPOSE,
  MARKETPLACE_CHAT_TOPIC_PURPOSE,
  SELF_MEDICATION_CHAT_TOPIC_PURPOSE,
} from '../../chat/constants/topic';
import { notificationService } from '../services';
import { createUserMessagingTopic } from '../utils';

interface IUseSubscribeToTopicsParams {
  deviceToken: string | null;
}

export function useSubscribeToTopics({
  deviceToken,
}: IUseSubscribeToTopicsParams) {
  const user = useAuthStore((state) => state.user);
  const authStatus = useAuthStore((state) => state.status);
  const topicsToSubscribe: string[] = [];

  const execute = async () => {
    if (topicsToSubscribe.length === 0) {
      return;
    }
    await notificationService.subscribeToTopics({
      deviceToken: deviceToken!,
      topics: topicsToSubscribe,
    });
  };

  const fetchKey = deviceToken ? 'subscribe-to-topics' : null;
  const { trigger } = useSWRMutation(fetchKey, async () => await execute());

  useEffect(() => {
    if (!user || authStatus !== 'success') {
      return;
    }

    topicsToSubscribe.push(
      createUserMessagingTopic({
        userId: user.props.id,
        purpose: MARKETPLACE_CHAT_TOPIC_PURPOSE,
      }),
      createUserMessagingTopic({
        userId: user.props.id,
        purpose: SELF_MEDICATION_CHAT_TOPIC_PURPOSE,
      }),
      createUserMessagingTopic({
        userId: user.props.id,
        purpose: COMPLAINT_CHAT_TOPIC_PURPOSE,
      })
    );
    if (fetchKey) {
      trigger();
    }
  }, [user, fetchKey]);
}
